import { Link } from "react-router-dom";
import { ArrowUpRight, FileText } from "lucide-react";

export default function SpotlightCard({ img, kicker, title, chips, to, specTo, testid, alt, onPricing }) {
  return (
    <div
      data-testid={testid}
      className="group relative block overflow-hidden border border-line bg-surface transition-colors duration-300 hover:border-signal/60"
    >
      <div className="relative h-72 overflow-hidden sm:h-80">
        <img
          src={img}
          alt={alt || title}
          loading="lazy"
          className="h-full w-full object-cover grayscale-[35%] transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-surface via-transparent to-transparent" />
        <div
          className="absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
          style={{ background: "radial-gradient(60% 60% at 50% 40%, rgba(16,185,129,0.18), transparent)" }}
        />
        <span className="absolute left-5 top-5 border border-signal/50 bg-ink/70 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.25em] text-neon backdrop-blur-sm">
          {kicker}
        </span>
      </div>
      <div className="p-6 sm:p-8">
        <h3 className="font-display text-3xl font-black uppercase tracking-tight text-white sm:text-4xl">
          <Link to={to} data-testid={`${testid}-title-link`} className="transition-colors hover:text-neon">
            {title}
          </Link>
        </h3>
        <div className="mt-4 flex flex-wrap gap-2">
          {chips.map((c) => (
            <span key={c} className="border border-line px-3 py-1 font-mono text-[11px] uppercase tracking-widest text-fog">
              {c}
            </span>
          ))}
        </div>
        <div className="mt-6 flex flex-wrap items-center gap-6">
          <Link
            to={to}
            data-testid={`${testid}-view`}
            className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-signal transition-colors hover:text-neon"
          >
            View system
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
          <Link
            to={specTo}
            data-testid={`${testid}-spec`}
            className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-fog transition-colors hover:text-neon"
          >
            <FileText className="h-4 w-4" />
            Full spec sheet
          </Link>
          {onPricing && (
            <button
              type="button"
              onClick={onPricing}
              data-testid={`${testid}-pricing`}
              className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-fog transition-colors hover:text-neon"
            >
              View pricing
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
